// extracted by mini-css-extract-plugin
export var avatarContainer = "_74-0";
export var avatarTypingWave = "_74-i";
export var gray = "_74-f";
export var green = "_74-c";
export var icon = "_74-9";
export var image = "_74-1";
export var lg = "_74-6";
export var md = "_74-5";
export var presenceDot = "_74-b";
export var red = "_74-d";
export var sm = "_74-4";
export var status = "_74-a";
export var typingDot = "_74-h";
export var typingPill = "_74-g";
export var xl = "_74-7";
export var xs = "_74-3";
export var xxl = "_74-8";
export var xxs = "_74-2";
export var yellow = "_74-e";